<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { breadcrumbStyles } from '../breadcrumb.styles';
  import type { BreadcrumbProps } from '../breadcrumb.types';

  const {
    children,
    css: cssProp,
    'aria-label': ariaLabel = 'Breadcrumb'
  }: BreadcrumbProps = $props();

  const classes = breadcrumbStyles.raw();
</script>

<nav class={css(classes.nav, cssProp)} aria-label={ariaLabel}>
  <ul class={cx(css(classes.list))}>
    {#if children}
      {@render children()}
    {/if}
  </ul>
</nav>
